﻿import {SubCategory} from './subCategory';
import {Word} from './word';

export class Category {
    id: string;
    name: string;
    subCategories: SubCategory[];
    words: Word[];

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.subCategories = json.subCategories;
        this.words = json.words;
    }
}
